module.exports = __webpack_public_path__ + "static/img/bg-index.c6644d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/siluqing/bg-index.png
// module id = NsHk
// module chunks = 1